import Vue from "vue";

Vue.filter("monthf", function(value) {
  if (!value) return "";
  value = parseInt(value);
  if (value == 1) {
    return value + " Month";
  } else {
    return value + " Months";
  }
});
Vue.filter("payfrqname", function(value) {
  if (!value) return "PrePaid";
  value = parseInt(value);
  switch (value) {
    case 0:
      return "PrePaid";
    case 1:
      return "Monthly";
    case 3:
      return "Quarterly";
    case 6:
      return "Bi-annually";
    case 12:
      return "Annually";
  }
});
Vue.filter("money", function(value) {
  if (!value) return "";
  value = parseFloat(value);
  return "£ " + value;
});
Vue.filter("justdate", function(value) {
  if (!value) return "";
  value = String(value);
  let ret = value.substring(0, 10);
  return ret;
});
Vue.filter("mobileno", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.slice(0, 4) + " " + value.slice(4, 7) + " " + value.slice(7);
});
Vue.filter("landtel", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.slice(0, 3) + " " + value.slice(3, 7) + " " + value.slice(7);
});
Vue.filter("nicelicence", function(value) {
  if (!value) return "";
  value = value.toString();
  return (
    value.slice(0, 5) +
    "-" +
    value.slice(5, 10) +
    "-" +
    value.slice(11, 17) +
    "-" +
    value.slice(17, 23) +
    "-" +
    value.slice(23)
  );
});

Vue.filter("last4Chars", str => str.substring(str.length - 4));
